'use client';

import React from 'react';
import { AuthProvider } from '@/contexts/AuthContext';
import { LanguageProvider } from '@/contexts/LanguageContext';

export function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider data-component-id="src/components/providers/ClientProviders.tsx:9:4" data-component-path="src/components/providers/ClientProviders.tsx" data-component-line="9" data-component-file="ClientProviders.tsx" data-component-name="AuthProvider" data-component-content="%7B%22elementName%22%3A%22AuthProvider%22%7D">
      <LanguageProvider data-component-id="src/components/providers/ClientProviders.tsx:10:6" data-component-path="src/components/providers/ClientProviders.tsx" data-component-line="10" data-component-file="ClientProviders.tsx" data-component-name="LanguageProvider" data-component-content="%7B%22elementName%22%3A%22LanguageProvider%22%7D">
        {children}
      </LanguageProvider>
    </AuthProvider>
  );
}